import React, { useState, useEffect } from "react";
import { Button, Row, Col, Container, Form } from "react-bootstrap"
import axios from "axios";
import toast from "react-hot-toast";
import ToastComponent from "./components/ToastComponent";

function HaDeviceNew() {
  const [result, setResult] = useState();
  const [name, setName] = useState();


  const createDevice = () => {
    let senddata =
      axios.post(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_device.json`,
        {
          ha_device: {
            name: name,
          }
        }
      )
      .then(( { data }) => {
        setResult(data)
      
      toast.promise(senddata, {
        loading: "Creating device",
        success: "device Created",
        error:   "Could not create device"
      })
      
    })
  }

  return (
    <div>
      <ToastComponent />
      <Container>
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
          <Form.Label column sm="2" className="Register-Label">
                Name
              </Form.Label>
              <Col sm="10">
                <Form.Control onChange={(e) => setName(e.target.value)} />
              </Col>
          </Form.Group>

        </Form>
        <Button onClick={() => createDevice()}>Create</Button>
      </Container>
    </div>

  )
}

export default HaDeviceNew